import ViewTemplate from "../view-template"
import {ViewType} from "../../../gd/const/views/view-type"
import {TasksView_List_SettingsDefault} from "../../../gd-modules/tasks-view/list/manager/settings/default"
import {TasksView_Table_DefaultAppSettings} from "../../../gd-modules/tasks-view/table/default-settings"
import viewMapDefaultAppSettings from "../../../gd-modules/map/manager/default-settings"
import {TasksView_Board_DefaultAppSettings} from "../../../gd-modules/tasks-view/board/default-settings"
import {GANTT_DEFAULT_SETTINGS} from "../../../gd-modules/gantt-chart/manager/default-settings"
import {CalendarDefaultSettings} from "../../../gd-modules/events/manager/default-settings"
import {Workload_DefaultSettings} from "../../../gd-modules/workload/manager/default-settings"
import viewDocumentsDefaultAppSettings from "../../../gd-modules/documents/manager/default-settings"
import viewProjectsDefaultAppSettings from "../../../../views/projects/default-settings"
import {viewTableDefaultAppSettings} from "../../../../views/table/manager/default-settings"
import {Summary_DefaultAppSettings} from "../../../../app/project/summary/manager/settings/default-settings"
import {PROJECT_PAGE_DEFAULT_SETTINGS} from "../../../../app/project/page/settings/default-settings"

export default function ViewTemplates_createDefaultTemplates() {
    let res: Partial<Record<ViewType, ViewTemplate>> = {
        [ViewType.PROJECT_LIST]                 : createDefaultTemplate(ViewType.PROJECT_LIST, TasksView_List_SettingsDefault),
        [ViewType.PROJECT_TABLE]                : createDefaultTemplate(ViewType.PROJECT_TABLE, TasksView_Table_DefaultAppSettings),
        [ViewType.PROJECT_TABLE_MAP]            : createDefaultTemplate(ViewType.PROJECT_TABLE_MAP, viewMapDefaultAppSettings),
        [ViewType.PROJECT_BOARD]                : createDefaultTemplate(ViewType.PROJECT_BOARD, TasksView_Board_DefaultAppSettings),
        [ViewType.PROJECT_GANTT]                : createDefaultTemplate(ViewType.PROJECT_GANTT, GANTT_DEFAULT_SETTINGS),
        [ViewType.PROJECT_CALENDAR]             : createDefaultTemplate(ViewType.PROJECT_CALENDAR, CalendarDefaultSettings),
        [ViewType.PROJECT_WORKLOAD]             : createDefaultTemplate(ViewType.PROJECT_WORKLOAD,Workload_DefaultSettings),
        [ViewType.PROJECT_DOCS]                 : createDefaultTemplate(ViewType.PROJECT_DOCS, viewDocumentsDefaultAppSettings),
        [ViewType.PROJECTS_PROJECTS_LIST]       : createDefaultTemplate(ViewType.CUSTOM_VIEW_PROJECTS_TABLE, viewProjectsDefaultAppSettings),
        [ViewType.CUSTOM_VIEW_PROJECTS_TABLE]   : createDefaultTemplate(ViewType.CUSTOM_VIEW_PROJECTS_TABLE, viewProjectsDefaultAppSettings),
        [ViewType.CUSTOM_VIEW_TASKS_TABLE]      : createDefaultTemplate(ViewType.CUSTOM_VIEW_TASKS_TABLE, viewTableDefaultAppSettings),
        [ViewType.PORTFOLIO_SUMMARY]            : createDefaultTemplate(ViewType.PORTFOLIO_SUMMARY, Summary_DefaultAppSettings),
        [ViewType.PROJECT_PAGE]                 : createDefaultTemplate(ViewType.PROJECT_PAGE, PROJECT_PAGE_DEFAULT_SETTINGS),
    }

    return res
}

function createDefaultTemplate(viewType:ViewType, appSettings:any) {
    return new ViewTemplate({
        id              : '_default',
        viewSystemType  : viewType,
        access          : "public",
        appSettings     : appSettings,
        name            : "Default",
        isDefault       : true
    })
}